import {TranslocoService} from "@ngneat/transloco";

// const {nanoid} = require('nanoid')
import {Injectable} from '@angular/core';
import {ISurvey} from "../../../../../../interfaces/ISurvey";
import {AppModeService} from "@store/services/app-mode.service";

@Injectable({
  providedIn: 'root'
})
export class HoneyPotService {

  questionID = 'hp_kz3220';
  rndQuestionIndex = Math.floor(Math.random() * 10);

  constructor(
    private translocoService: TranslocoService,
    private appModeService: AppModeService,

  ) {
  }

  injectHoneyPotQuestion(rawSurvey: ISurvey): ISurvey {

    if(this.appModeService.isTestSurvey$.value){
      return rawSurvey;
    }
    // console.log('[HoneyPotService]', rawSurvey);

    // First page.
    const firstPageGroupIndex = rawSurvey.surveyDef.structureElements.pagesGroupsIndex[0];
    const firstPageIndex = rawSurvey.surveyDef.structureElements.pagesGroups.pagesIndex[firstPageGroupIndex][0];
    const firstQuestionIndex = rawSurvey.surveyDef.structureElements.pages.questionsGroupsIndex[firstPageIndex][0];

    // console.log(`FirstPage Group Index: ${firstPageGroupIndex}`);
    // console.log(`FirstPage Index: ${firstPageIndex}`);
    // console.log(`First Question Index: ${firstQuestionIndex}`);


    rawSurvey = {
      ...rawSurvey,
      surveyDef: {
        ...rawSurvey.surveyDef,
        structureElements: {
          ...rawSurvey.surveyDef.structureElements,
          questionsGroups: {
            ...rawSurvey.surveyDef.structureElements.questionsGroups,
            questionsIndex: {
              ...rawSurvey.surveyDef.structureElements.questionsGroups.questionsIndex,
              [firstQuestionIndex]: [
                this.questionID,
                ...rawSurvey.surveyDef.structureElements.questionsGroups.questionsIndex[firstQuestionIndex],
              ]
            }
          }
        },
        questions: {
          ...rawSurvey.surveyDef.questions,
          [this.questionID]: this.getRawQuestion(),
        }
      }
    }

    // console.log('[OUT:]', rawSurvey);
    return rawSurvey;

  }

  getRawQuestion(): any {

    const rowId = `r_hp_kz3220`;
    const statementId = `s_hp_kz3220`;

    const question = this.getRandomQuestion();

    return {
      "isOptional": true,
      "key": this.questionID,
      "limitAnswersAmount": false,
      "matrixType": "open",
      "maxAnswers": {
        "rows": 0,
        "statements": 0
      },
      "minAnswers": {
        "rows": 0,
        "statements": 0
      },
      "positionLocked": false,
      "question": {
        [this.translocoService.getActiveLang()]: question[this.translocoService.getActiveLang()],
      },
      "randomizeRows": false,
      "randomizeStatements": false,
      "rows": {
        [rowId]: {
          "isOpen": true,
          "key": rowId,
          "label": {
            "fr": ""
          },
          "media": {
            "fr": ""
          },
          "openCols": {
            [statementId]: true
          },
          "openDetailsForAnno": {
            "category": "",
            "type": ""
          },
          "rulesProperties": {
            "description": "",
            "label": ""
          },
          "statement": {
            "fr": "Nouveau libellé"
          },
          "type": "rows",
          "version": "2022.0"
        }
      },
      "rowsOrder": [
        rowId
      ],
      "rulesProperties": {
        "description": "",
        "label": ""
      },
      "shortLabel": {
        [this.translocoService.getActiveLang()]: question['id'],
      },
      "shouldSaveInExtProfile": false,
      "statements": {
        [statementId]: {
          "isOpen": true,
          "key": statementId,
          "label": {
            "fr": ""
          },
          "media": {
            "fr": ""
          },
          "openDetailsForAnno": {
            "category": "",
            "type": ""
          },
          "rulesProperties": {
            "description": "",
            "label": ""
          },
          "statement": {
            "fr": "Nouveau libellé"
          },
          "type": "statements",
          "version": "2022.0"
        }
      },
      "statementsOrder": [
        statementId
      ],
      "type": "open",
      "uniqueMentionKey": "",
      "useImage": false,
      "useLabel": false,
      "useUniqueMentionLabel": false,
      "version": "2022.0",
      "viewerType": "honeyPot"
    };

  }

  getRandomQuestion() {

    const questionsIndex = [
      {
        "id": "produit_prefere",
        "fr": "Quel est votre produit préféré dans notre gamme?",
        "en": "What is your favorite product in our range?"
      },
      {
        "id": "produits_repondent_besoins",
        "fr": "Est-ce que nos produits répondent à vos besoins?",
        "en": "Do our products meet your needs?"
      },
      {
        "id": "decouverte_entreprise",
        "fr": "Comment avez-vous entendu parler de notre entreprise pour la première fois?",
        "en": "How did you first hear about our company?"
      },
      {
        "id": "amelioration_produits",
        "fr": "Quelle amélioration suggéreriez-vous pour nos produits?",
        "en": "What improvements would you suggest for our products?"
      },
      {
        "id": "satisfaction_service_client",
        "fr": "Dans quelle mesure êtes-vous satisfait du service client?",
        "en": "How satisfied are you with customer service?"
      },
      {
        "id": "facilite_achat_site",
        "fr": "Avez-vous trouvé facile d'acheter sur notre site Web?",
        "en": "Did you find it easy to shop on our website?"
      },
      {
        "id": "recommandation_produits",
        "fr": "Recommanderiez-vous nos produits à un ami?",
        "en": "Would you recommend our products to a friend?"
      },
      {
        "id": "suggestions_produits",
        "fr": "Avez-vous des suggestions d'autres produits que vous aimeriez voir dans notre boutique?",
        "en": "Do you have suggestions of other products you would like to see in our shop?"
      },
      {
        "id": "derniere_experience_achat",
        "fr": "Quelle a été votre dernière expérience d'achat avec nous?",
        "en": "What was your most recent buying experience with us?"
      },
      {
        "id": "amelioration_experience_achat",
        "fr": "Comment pourrions-nous améliorer votre expérience d'achat?",
        "en": "How could we improve your shopping experience?"
      }
    ]

    return questionsIndex[this.rndQuestionIndex];

  }

}
